import { employeesRepositoryImpl } from './repository';
import EmployeeService from './service/EmployeeServiceImpl';

const employeeService = new EmployeeService(employeesRepositoryImpl);

export { employeeService };
